module.exports = __webpack_public_path__ + "static/media/map.194a4e13.jpg";